module.exports = __webpack_public_path__ + "static/media/walletconnect-banner.e1cb8d21.png";